export default __webpack_public_path__ + "static/media/img02.a778ae37.svg";